/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'ca-content/content/content',
	'../nls/StringResources',
	'react',
	'react-dom'
], function (content, StringResources, React, ReactDOM) {

	class SearchContentPageView {
		constructor(options) {
			this.glassContext = options.glassContext;
			this.el = (options.$el && options.$el[0]) || this._initDomElement();
			this.searchTerm = options.searchTerm;
		}

		render() {
			const options = {
				glassContext: this.glassContext,
				searchTerm: this.searchTerm,
				ref: ref => this.searchPageView = ref
			};
			ReactDOM.render(React.createElement(content.SearchContentPageView, options), this.el);
			return Promise.resolve();
		}

		activate(content) {
			this.updateContentPage(content);
			return Promise.resolve();
		}

		deactivate() {
			return Promise.resolve();
		}

		show() {
			this.el.setAttribute('style', 'display: block;');
		}

		setFocus() { }

		_initDomElement() {
			const el = document.createElement('div');
			el.classList.add('contentPageView');
			return el;
		}

		getTitle() {
			return StringResources.get('searchContentPageTitle');
		}

		updatePerspectiveContext(context) {
			this.updateContentPage(context.content);
			this.glassContext.updateCurrentCachedAppView();
			this.glassContext.currentPerspective.updateRenderState(true);
		}

		updateContentPage(content) {
			if (this.searchTerm !== content.searchTerm || !this.searchPageView) {
				this.searchTerm = content.searchTerm;
				this.render();
			} else {
				this.searchPageView.forceUpdate();
			}
		}

		getContent() {
			return {
				searchTerm: this.searchTerm
			};
		}
	}

	return SearchContentPageView;
});